<dx-popover
  (onHiding)="hiding.emit()"
  [(visible)]="visible"
  [animation]="true"
  [position]="popoverPosition"
  [shadingColor]="isMobile ? 'rgba(0, 0, 0, 0.6)' : ''"
  [shading]="isMobile && showBackdrop"
  [target]="target"
  [width]="width ? width : 'auto'"
  [wrapperAttr]="{ class: extraClass || '' }"
  hideOnOutsideClick="true"
  (onShown)="relocateFilter()"
>
  <div class="cm-popover">
    <div *ngIf="showCloseIcon" data-cy="cy-popover-close" class="cm-popover__close">
      <button mat-icon-button (click)="closePopOver($event)">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="cm-popover__content" data-cy="popover-content" (cdkObserveContent)="onContentChange($event)">
      <ng-content></ng-content>
    </div>
  </div>
</dx-popover>
